import {
  documentsDestroyMutation,
  leadsDocumentsListQueryKey,
  opportunitiesDocumentsListQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'

import { App } from 'antd'
import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

export const DeleteDocument = ({
  document,
  onCancel,
  ...props
}: ActionsType) => {
  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { id: leadId, opportunityId } = useParams()
  const { t } = useLocales()

  const { notification } = App.useApp()

  const { mutate, isPending } = useMutation({
    ...documentsDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsDocumentsListQueryKey({ path: { lead_id: String(leadId) } }),
        opportunitiesDocumentsListQueryKey({
          path: { opportunity_id: String(opportunityId) }
        })
      ])

      notification.success({
        message: t('success.success'),
        description: t('success.success_data_delete')
      })

      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onDelete = () => {
    if (!document.id) return

    mutate({ path: { id: document.id } })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
